// Switch.js
import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const StyledContainer = styled.div`
    border-radius: ${props => props.theme.defaults.borderRadius};
    border: 1px solid ${props => props.theme.colours.flat.darkGray.hex};
    display: flex;
    height: 100%;
    width: 100%;

    /* transient prop $containerStyles - won't be forwarded to the DOM */
    ${props => props.$containerStyles}
`;

const StyledButton = styled.button`
    flex: 1;
    border: 0;
    outline: none;
    border-radius: ${props => {
        if (props.first) {
            return props.theme.defaults.borderRadius + " 0 0 " + props.theme.defaults.borderRadius;
        }
        return "0 " + props.theme.defaults.borderRadius + " " + props.theme.defaults.borderRadius + " 0";
    }};
    background: ${props =>
        props.selected ? props.theme.colours.flat.darkGray.hex : props.theme.colours.flat.white.hex};
    color: ${props => (props.selected ? props.theme.colours.flat.white.hex : props.theme.colours.flat.darkGray.hex)};
    height: 100%;
    width: 100%;
    font-size: clamp(1.5rem, 3vw, 2rem);
`;

const Switch = ({
    first,
    second,
    firstLabel,
    secondLabel,
    onToggle = () => {},
    defaultValue,
    height,
    containerStyles
}) => {
    const [selected, setSelected] = useState(defaultValue || first);

    const handleToggle = e => {
        e.preventDefault();
        const value = e.currentTarget.value;
        setSelected(value);
        onToggle && onToggle(value);
    };

    return (
        <StyledContainer $containerStyles={containerStyles}>
            <StyledButton
                value={first}
                first={true}
                onClick={handleToggle}
                selected={first.toLowerCase() === selected.toLowerCase()}
                height={height}
            >
                {firstLabel || first}
            </StyledButton>

            <StyledButton
                value={second}
                first={false}
                onClick={handleToggle}
                selected={second.toLowerCase() === selected.toLowerCase()}
                height={height}
            >
                {secondLabel || second}
            </StyledButton>
        </StyledContainer>
    );
};

Switch.propTypes = {
    first: PropTypes.string.isRequired,
    second: PropTypes.string.isRequired,
    /** Optional display label for the first button (defaults to `first`) */
    firstLabel: PropTypes.string,
    /** Optional display label for the second button (defaults to `second`) */
    secondLabel: PropTypes.string,
    onToggle: PropTypes.func,
    defaultValue: PropTypes.string,
    height: PropTypes.string,
    fontSize: PropTypes.string,
    /** a css string or a styled-components css`` chunk */
    containerStyles: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default Switch;
